

(function currencyInputDirectiveDefinition() {

    'use strict';

    var CURRENCY_REGEX = null,                      // Regex de validaci�n
        CURRENCY_SANITIZE_REGEX = null,             // Regex que se usa para remover caracteres inv�lidos.
        CURRENCY_CARET_REGEX = null,                // Regex utilizada para mover el caret del input cuando se habilita el formatting
        CURRENCY_REMOVE_GROUPS_REGEX = null,        // Regex utilizada para remover los separadores de grupo
        CURRENCY_REMOVE_DECIMALS_REGEX = null,      // Regex utilizada para remover los separadores de decimal que no aplican.
        CURRENCY_EXTRACT_DECIMALS_REGEX = null,     // Regex utilizada para truncar los decimales a 2 en un n�mero de la forma XXXXXXXXXXX,YYYYYY 
        CURRENCY_ONLY_DECIMALS = null;              // Regex utilizada para saber si solo quedan decimales y un digito.

    var maxNumLength = '9.999.999.999.999,99'.length;   // M�ximo n�mero representable por el control

    var validKeysArray = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58];

    angular.module('Currency')
        .run([
            '$locale', '$rootScope', function ($locale, $rootScope) {

                function currencyRegex() {
                    var pattern = $locale.NUMBER_FORMATS.PATTERNS[1];

                    CURRENCY_REGEX = new RegExp("^"
                        + "((" + RegExp.escape(pattern.negPre).replace('\u00a0', '\\s?').replace('\u00a4', '') + ")|(" + RegExp.escape(pattern.posPre).replace('\u00a0', '\\s?').replace('\u00a4', '') + "))?"      // El prefijo de neg o pos
                        + "(([1-9][0-9]{0,2}(" + RegExp.escape($locale.NUMBER_FORMATS.GROUP_SEP) + "[0-9]{" + pattern.gSize + "})*)|[0-9]+)?"
                        + "(" + RegExp.escape($locale.NUMBER_FORMATS.DECIMAL_SEP) + "[0-9]{1," + pattern.maxFrac + "})?"                                                                                            // los decimales
                        + "((" + RegExp.escape(pattern.negSuf).replace('\u00a0', '\\s?').replace('\u00a4', '') + ")|(" + RegExp.escape(pattern.posSuf).replace('\u00a0', '\\s?').replace('\u00a4', '') + "))?$");   // el posfijo

                    CURRENCY_SANITIZE_REGEX = new RegExp("[^0-9" + RegExp.escape(pattern.negPre).replace('\u00a0', '\\s?').replace('\u00a4', '')
                                                                 + RegExp.escape(pattern.posPre).replace('\u00a0', '\\s?').replace('\u00a4', '')
                                                                 + RegExp.escape(pattern.posSuf).replace('\u00a0', '\\s?').replace('\u00a4', '')
                                                                 + RegExp.escape(pattern.negSuf).replace('\u00a0', '\\s?').replace('\u00a4', '')
                                                                 + RegExp.escape($locale.NUMBER_FORMATS.GROUP_SEP)
                                                                 + RegExp.escape($locale.NUMBER_FORMATS.DECIMAL_SEP)
                                                                 + "]", 'ig');

                    CURRENCY_CARET_REGEX = new RegExp("[^0-9" + RegExp.escape($locale.NUMBER_FORMATS.DECIMAL_SEP) + "]", 'i');

                    CURRENCY_REMOVE_GROUPS_REGEX = new RegExp("(?:" + RegExp.escape($locale.NUMBER_FORMATS.GROUP_SEP) + ")", 'ig');

                    CURRENCY_ONLY_DECIMALS = new RegExp("\\d(?:" + RegExp.escape($locale.NUMBER_FORMATS.DECIMAL_SEP) + ")\\d*", 'i');

                    CURRENCY_REMOVE_DECIMALS_REGEX = new RegExp(RegExp.escape($locale.NUMBER_FORMATS.DECIMAL_SEP) + "(?=\\d*" + RegExp.escape($locale.NUMBER_FORMATS.DECIMAL_SEP) + ")", 'ig');

                    CURRENCY_EXTRACT_DECIMALS_REGEX = new RegExp("^"
                        + "(?:(?:" + RegExp.escape(pattern.negPre).replace('\u00a0', '\\s?').replace('\u00a4', '') + ")|(?:" + RegExp.escape(pattern.posPre).replace('\u00a0', '\\s?').replace('\u00a4', '') + "))?"      // El prefijo de neg o pos
                        + "(\\d+)"
                        + "(" + RegExp.escape($locale.NUMBER_FORMATS.DECIMAL_SEP) + "[0-9]{1," + pattern.maxFrac + "})?(?:\\d*)"                                                                                            // los decimales
                        + "(?:(?:" + RegExp.escape(pattern.negSuf).replace('\u00a0', '\\s?').replace('\u00a4', '') + ")|(?:" + RegExp.escape(pattern.posSuf).replace('\u00a0', '\\s?').replace('\u00a4', '') + "))?$");   // el posfijo


                    if(pattern.negPre)
                        validKeysArray.push(pattern.negPre.charCodeAt(0));
                    if(pattern.posPre)
                        validKeysArray.push(pattern.posPre.charCodeAt(0));
                    if(pattern.posSuf)
                        validKeysArray.push(pattern.posSuf.charCodeAt(0));
                    if(pattern.negSuf)
                        validKeysArray.push(pattern.negSuf.charCodeAt(0));
                    if($locale.NUMBER_FORMATS.GROUP_SEP)
                        validKeysArray.push($locale.NUMBER_FORMATS.GROUP_SEP.charCodeAt(0));
                    if($locale.NUMBER_FORMATS.DECIMAL_SEP)
                        validKeysArray.push($locale.NUMBER_FORMATS.DECIMAL_SEP.charCodeAt(0));
                }

                currencyRegex();

                $rootScope.$on('$localeChangeSuccess', currencyRegex);

            }
        ])
        .directive('currency', [
            '$filter', '$compile', '$locale', '$rootScope',
            function currencyDirective($filter, $compile, $locale, $rootScope) {
                return {
                    restrict: 'A',
                    require: 'ngModel',
                    link: function (scope, element, attr, ngModelCtrl) {

                        $rootScope.$on('$localeChangeSuccess', ngModelCtrl.$render);

                        var newScope = scope.$new(),
                            localMaxNumLength = maxNumLength;

                        newScope.symbol = function symbol() {
                            if (!angular.isDefined(attr.currencySymbol))
                                return $locale.NUMBER_FORMATS.CURRENCY_SYM;
                            return attr.currencySymbol;
                        };

                        if (element.attr('maxlength')) {
                            localMaxNumLength = parseInt(element.attr('maxlength'));
                        }
                        element.attr('maxlength', localMaxNumLength + 1);

                        if (!attr.currencyNoSymbol) {
                            var wrapper = angular.element('<div class="input-group currency-wrapper"></div>');

                            if (attr.currencyWrapperClass) {
                                wrapper.addClass(attr.currencyWrapperClass);
                            }

                            element.wrap(wrapper);

                            var sym = angular.element('<span class="input-group-addon currency-addon">{{symbol()}}</span>');

                            if (attr.currencySymbolClass) {
                                sym.addClass(attr.currencySymbolClass);
                            }

                            $compile(sym)(newScope);
                            sym.insertBefore(element);
                        }

                        var formatInput = (attr.currencyFormatted === ''),
                            formatting = false;

                        function formatInputValue(element, modelValue) {

                            var currVal = element.val().replace(CURRENCY_SANITIZE_REGEX, '');
                            var niceVal = $filter('currency')(modelValue, '').replace(/\s/g, '');
                            var currPos = getCaretPosition(element);
                            
                            element.val(niceVal);
                            // actualizo el view value -> esto triggerea un parse en el commit
                            formatting = true;
                            ngModelCtrl.$setViewValue(niceVal);
                            ngModelCtrl.$commitViewValue(); // por si se us� debounce
                            formatting = false;

                            if (niceVal.indexOf(currVal) === 0) {
                                // la caret va en el mismo lugar
                                setCaretPosition(element[0], currPos);
                            } else {
                                // me tengo que fijar en que n�mero estaba la caret y volver a ponerla ahi
                                // 1- cuento los numeros hasta la caret (sin contar cosas que no sean numero)
                                var numIndex = 0,
                                    caretPos = 0;

                                for (var i = 0; i < currVal.length && i < currPos; i++) {
                                    if (!CURRENCY_CARET_REGEX.test(currVal.charAt(i))) {
                                        numIndex++;
                                    }
                                }

                                // ahora seteo la caret en el mismo n�mero
                                for (var i = 0; caretPos < niceVal.length && numIndex > 0; i++) {
                                    if (!CURRENCY_CARET_REGEX.test(niceVal.charAt(i))) {
                                        numIndex--;
                                    }
                                    caretPos++;
                                }

                                setCaretPosition(element[0], caretPos);
                            }
                        }

                        var deletedDecimal = false;

                        if (formatInput) {
                            element.on('keydown', function (evt) {
                                var val = element.val();

                                if (evt.which === 8) {
                                    // se apret� backspace: Si la caret est� en la posici�n anterior a una coma entonces 
                                    // asumo que borr� el decimal y lo �nico que hago es mover el caret.
                                    var currPos = getCaretPosition(element);
                                    
                                    // Veo si es el separador de decimales y lo salteo.
                                    if (currPos - 1 < val.length) {
                                        if (val[currPos-1] === $locale.NUMBER_FORMATS.DECIMAL_SEP) {
                                            setCaretPosition(element[0], currPos - 1);
                                            return false;
                                        } else if (currPos === 1) {
                                            // si est� en la segunda posici�n me fijo que lo que 
                                            // queda no sea solo decimales y si es as� los borro
                                            if (CURRENCY_ONLY_DECIMALS.test(val)) {
                                                element.val('');
                                            }
                                        }
                                    }
                                }
                                return true;
                            });

                            $(element[0]).keypress(function (evt) {

                                var val = element.val();

                                if (validKeysArray.indexOf(evt.which) === -1) {
                                    return false;   // no es un caracter v�lido
                                }

                                if (val.length === localMaxNumLength) {

                                    var index = val.indexOf($locale.NUMBER_FORMATS.DECIMAL_SEP);
                                    var caret = getCaretPosition(element);

                                    // si estoy a la izquierda de la comma entonces retorno false
                                    if (index !== -1 && caret >= index) {
                                        if (index === caret) {
                                            // est� en la coma, lo dejo si se escribi� una coma
                                            return (evt.which === $locale.NUMBER_FORMATS.DECIMAL_SEP.charCodeAt(0))
                                        } else {
                                            // est� despues de la coma
                                            return true;
                                        }
                                    }

                                    return false;
                                }
                            });
                        }

                        ngModelCtrl.$parsers.unshift(function (viewValue) {

                            if (formatting) {
                                return viewValue;
                            }

                            if (ngModelCtrl.$isEmpty(viewValue)) {
                                ngModelCtrl.$setValidity('currency', false);
                                return null;
                            }

                            viewValue = viewValue.replace(/\s/g, '');

                            if (formatInput) {
                                // si introdujo otra cosa que no sea numero o GROUP_SEP / DECIMAL_SEP entonces 
                                // lo reemplazo por vacio
                                // Le agrego el 0 por si tipean una ',' primero
                                viewValue = ('0' + viewValue).replace(CURRENCY_SANITIZE_REGEX, '')
                                                            .replace(CURRENCY_REMOVE_GROUPS_REGEX, '')
                                                            .replace(CURRENCY_REMOVE_DECIMALS_REGEX, '')
                                                            .replace(CURRENCY_EXTRACT_DECIMALS_REGEX, '$1$2');

                                if (viewValue.charAt(viewValue.length - 1) === $locale.NUMBER_FORMATS.DECIMAL_SEP) {
                                    // remover la �ltima coma
                                    viewValue = viewValue.substr(0, viewValue.length - 1);
                                }
                            }

                            if (CURRENCY_REGEX.test(viewValue)) {

                                // reemplazo el separador de grupos por ''
                                if (!formatInput) {
                                    viewValue = viewValue.replace(CURRENCY_REMOVE_GROUPS_REGEX, '');
                                }

                                // reemplazo el separador decimal por un .
                                viewValue = viewValue.replace($locale.NUMBER_FORMATS.DECIMAL_SEP, '.');

                                var result = parseFloat(viewValue);

                                if (result === NaN) {
                                    ngModelCtrl.$setValidity('currency', false);
                                    return undefined;
                                }

                                ngModelCtrl.$setValidity('currency', true);

                                if (formatInput) {
                                    formatInputValue(element, result);
                                }

                                return result;
                            }

                            ngModelCtrl.$setValidity('currency', false);

                            return undefined;
                        });


                        ngModelCtrl.$formatters.unshift(function (value) {

                            if (value) {
                                // formateo el string
                                value = $filter('currency')(value, '').replace(/\s/g, '');
                            }

                            return value;
                        });

                        if (attr.min || attr.ngMin) {
                            var minVal;

                            ngModelCtrl.$validators.min = function (value) {
                                return ngModelCtrl.$isEmpty(value) || angular.isUndefined(minVal) || value >= minVal;
                            };

                            attr.$observe('min', function (val) {
                                if (angular.isDefined(val) && !angular.isNumber(val)) {
                                    val = parseFloat(val, 10);
                                }
                                minVal = angular.isNumber(val) && !isNaN(val) ? val : undefined;

                                ngModelCtrl.$validate();
                            });
                        }

                        if (attr.max || attr.ngMax) {
                            var maxVal;
                            ngModelCtrl.$validators.max = function (value) {
                                return ngModelCtrl.$isEmpty(value) || angular.isUndefined(maxVal) || value <= maxVal;
                            };

                            attr.$observe('max', function (val) {
                                if (angular.isDefined(val) && !angular.isNumber(val)) {
                                    val = parseFloat(val, 10);
                                }
                                maxVal = angular.isNumber(val) && !isNaN(val) ? val : undefined;

                                ngModelCtrl.$validate();
                            });
                        }
                    }
                };
            }]);

})();